// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { VvDavtAreaId } from './VvDavtAreaId'
import { VvDavtAreaNavigation } from './VvDavtAreaNavigation'
import { VvDavtAreaRoutes } from './VvDavtAreaRoutes'

const LazyVvDavtComponent = lazy(() => import('./VvDavtArea'))

const VvDavtComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyVvDavtComponent />
  </SuspenseLoadingWrapper>
)

export const VvDavtArea = {
  id: VvDavtAreaId,
  requiredRight: BoumRight.AREA_ADMIN_PANEL_VV_DAVT,
  NavigationComponent: VvDavtAreaNavigation,
  route: {
    path: VvDavtAreaRoutes.route,
    component: VvDavtComponent,
  },
}
